const isDOM = el => el instanceof Element;

async function displayFaq() {
  const faqElsWrapper = document.querySelector(".faq-elements-wrapper-bds");
  const faqAnchorsWrapper = document.querySelector(".faq-anchors-wrapper-bds");
  const faqSections = await document.querySelectorAll('[id*="_faq"]');

  let questionId = 0;
  
  faqSections.forEach( faq => {
    questionId += 1;
    
    const faqQuestion = document.createElement("div");
    faqQuestion.classList.add("faq-sections-bds");
    const faqSection = document.createElement("div");
    faqSection.classList.add("faq-section-bds");

    /**** création des éléments du menu latérale de FAQ ****/
    // Récupère le titre et créer l'élément de dom
    const faqTitle = document.createElement("p");
    const title = faq.children[1].children[0].children[0].children[0].children[0].innerText;
    const cleanedTitle = title.replace(/\n\s\n/g, " ");
    faqTitle.innerText = cleanedTitle;

    // Créer un wrapper pour le titre et l'icone d'affichage/masquage des questions
    const faqTitleWrapper = document.createElement("div");
    faqTitleWrapper.classList.add("faq-title-bds");
    
    faqTitleWrapper.appendChild(faqTitle);
    faqSection.appendChild(faqTitleWrapper);

    // Récupère les questions et ajoute les éléments de dom à faqSection
    const faqQuestionsWithBorder = faq?.children[1]?.children[0]?.children[1]?.children[0]?.children[0]?.children;
    const faqQuestionsWithoutBorder = faq?.children[1]?.children[0]?.children[0]?.children[0]?.children[1]?.children;
    const faqQuestions = faqQuestionsWithBorder ? faqQuestionsWithBorder : faqQuestionsWithoutBorder;
    
    for (const index in faqQuestions) {
      // créer une ancre pour chaque question
      const questions = document.createElement("a");
      questions.setAttribute("href", `#question-anchor-${questionId}-${index}`);
      questions.setAttribute("id", `question-${questionId}-${index}`);
      questions.innerText = faqQuestions[index]?.innerText;
    

      if (isDOM(faqQuestions[index])) {
        // faqQuestions[index].setAttribute("id", `question-anchor-${questionId}-${index}`);
        faqQuestions[index].setAttribute("class", `question-anchor`);

        const spanAnchor = document.createElement("span");
        spanAnchor.classList.add("anchor-bds")
        spanAnchor.setAttribute("id", `question-anchor-${questionId}-${index}`);
        
        faqQuestions[index].appendChild(spanAnchor);
        faqQuestion.appendChild(questions);
      }
          
      // Ecoute le clique sur une questions dans la barre latérale
      questions.addEventListener( "click", () => {
        const expandedAria = faqQuestions[index].children[0];
        const isExpanded = expandedAria.ariaExpanded === "true";
        !isExpanded ? faqQuestions[index].children[0].children[0].click() : "";
      });
    }

    faqSection.appendChild(faqQuestion);
    faqAnchorsWrapper.appendChild(faqSection);
    faqElsWrapper.appendChild(faq);
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", displayFaq);
  htmlBds.style.scrollBehavior = "smooth";
} else {
  displayFaq();
  const htmlBds = document.querySelector("html");
  htmlBds.style.scrollBehavior = "smooth";
}
















